// web/src/lib/processOrder.ts — pure list edits for « Processus de l'agent ».
export interface PathStep { key: string; on: boolean }
export function moveStep(list: PathStep[], key: string, to: number): PathStep[] {
  const from = list.findIndex((s) => s.key === key);
  if (from < 0 || to < 0 || to >= list.length || to === from) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}
export function toggleStep(list: PathStep[], key: string, locked: ReadonlySet<string>): PathStep[] {
  if (locked.has(key)) return list;
  return list.map((s) => (s.key === key ? { ...s, on: !s.on } : s));
}

/** Fields the website always sends (« Ce que Shopify envoie vraiment », 2026-10-15). */
export const SITE_KNOWN: ReadonlySet<string> = new Set(['name', 'phone', 'pack', 'title', 'payment_method', 'order']);

/** « Relances 24 / 48 h », or '' when the step has none. */
export function reminderLine(hours: number[], t: (s: string, v?: Record<string, string | number>) => string): string {
  return hours.length ? t('Relances {h} h', { h: hours.join(' / ') }) : '';
}
